import request from './request';
import trim from './trimHelper';

export function fetchGET(url, params) {
  const options = {
    method: 'GET',
    credentials: 'include',
  };

  let urlWithParams = url;
  if (params) {
    const trimmedParams = trim(params);

    const queryString = Object.keys(trimmedParams)
      .map(
        k => `${encodeURIComponent(k)}=${encodeURIComponent(trimmedParams[k])}`
      )
      .join('&');

    urlWithParams = `${url}?${queryString}`;
  }

  return request(urlWithParams, options);
}

export function fetchPOST(url, body) {
  const trimmedBody = trim(body);

  const options = {
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(trimmedBody),
  };

  return request(url, options);
}
